// 教务中心api
import request from "@/config/_requestLoding";
// import qs from "qs";
//获得比赛排名列表
export function getContestRankList(params) {
    return request({
        url: "/api/oj/get/contest/rank/list",
        params,
        method: "get",
        // noLoading: true
    });
}
//获得比赛题目列表
export function getProblemForContest(params) {
    return request({
        url: "/api/oj/get/problem/for/contest",
        params,
        method: "get",
        // noLoading: true
    });
}
//获得用户比赛排名信息
export function getUserContestRank(params) {
    return request({
        url: "/api/oj/get/user/contest/rank",
        params,
        method: "get",
    });
}
//排行
export function h5GetContestRankList(params) {
    return request({
        url: "/api/h5/getContestRankList",
        params,
        method: "get",
    });
}
//h5页面获得oj总排名
export function h5GetOjTotalRank(params) {
    return request({
        url: "/api/h5/getOjTotalRank",
        params,
        method: "get",
    });
}